import React from "react";
import Table from "../../Common/Table";

import Permission from "../../Common/Permission";
import TableFields from "../../../constants/PrizeItem/TableFields.json";
import { getPath } from "../../../utils";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import { Pill } from "../../../constants/assets/containers";

const PrizeItemList = ({ handleClick, prizeItemList }) => {
  const allActions = MenuActionsMappings[MenuNames.PRIZE_ITEMS];

  const getFieldValue = (prizeItem, key) => {
    switch (key) {
      case "status":
        if (prizeItem["status"] === "inactive") {
          return <Pill isFalse={true}>Inactive</Pill>;
        }
        return <Pill isFalse={false}>Active</Pill>;
      case "actions":
        return (
          <Permission
            optionalPerms={[allActions.DETAIL, allActions.UPDATE]}
            notAllowedText="No Actions Allowed"
          >
            <span
              onClick={() => handleClick("Edit", prizeItem)}
              className={"edit-options cursor-pointer"}
            >
              View/Edit
            </span>
          </Permission>
        );
      default:
        return getPath(prizeItem, key, "NA");
    }
  };

  return (
    <Permission requiredPerms={[allActions.LIST]}>
      <Table
        list={prizeItemList}
        getFieldValue={getFieldValue}
        fields={TableFields}
      />
    </Permission>
  );
};

export default PrizeItemList;
